import SearchResults from './SearchResults.svelte';

// Hacked to not unmount. Need to look into svelte unmount,
// and ensure event handlers are properly removed for unmount
var hasInited = false;
var comp = {
	comp: null
};
registerComp('search-comp', function(page, arg) {
	if (!hasInited) {
		hasInited = true;
		comp.comp = new SearchResults({
			target: document.getElementById("brygga-search-input-wrap"),
			props: {
				inputId: 'brygga-search'
			}
		});
	}
	return {};
});

export default comp;